export default __webpack_public_path__ + "static/media/hero_converted.5c17b66c.jpg";